import { useState } from "react";
import { approveCbreInvoice } from "../utils/cbreInvoiceRegistry";
import { runWithCorrectionPrompt } from "../services/financeCore/invoiceCorrection";
import TaxTreatmentPanel from "./TaxTreatmentPanel";

export default function CbreApprovalControls({ invoice }) {
  const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().slice(0, 10));
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [approved, setApproved] = useState(false);

  async function approve() {
    setSaving(true);
    setMessage("");
    try {
      const saved = await runWithCorrectionPrompt((options) => approveCbreInvoice(invoice, invoiceDate, options));
      setMessage(saved.unchanged
        ? `${saved.invoiceNumber} is already approved with exactly these figures — nothing to change.`
        : saved.corrected
          ? `${saved.invoiceNumber} corrected for ${saved.monthKey}. The receivable and P&L now use the new figures.`
          : `${saved.invoiceNumber} approved and recorded for ${saved.monthKey}.`);
      setApproved(true);
    } catch (error) {
      setMessage(error.message || "Invoice approval failed.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ marginTop: 12 }}>
      <TaxTreatmentPanel clientCode="CBRE" normalized={{
        serviceChargeSubtotal: invoice.totals.invoiceAmount,
        gstAmount: invoice.totals.salesTax,
        grossAmount: invoice.totals.totalAmount,
        recoveryBase: null
      }} />
      <div className="form-grid" style={{ marginTop: 12 }}>
        <div className="field">
          <label>Invoice Date</label>
          <input className="input" type="date" value={invoiceDate} disabled={approved}
            onChange={(event) => setInvoiceDate(event.target.value)} />
        </div>
      </div>
      <button className="btn btn-success" type="button" style={{ marginTop: 8 }}
        disabled={saving || approved} onClick={approve}>
        {approved ? "Approved" : saving ? "Saving approval…" : "Approve & Save Invoice"}
      </button>
      {message && <p className="page-copy" role="status" style={{ marginTop: 10 }}>{message}</p>}
    </div>
  );
}
